import { CreateCustomBudgetTrackedComponent } from "@pages/mmm/amplitude-tracking/components";
import { MMMTab } from "@pages/mmm/amplitude-tracking/mmm-event";
import { useTrackMMMEvent } from "@pages/mmm/amplitude-tracking/use-track-mmm-event";
import { useClientKpis } from "@pages/mmm/hooks/use-client-kpis";

import { KpiSelect } from "../../shared/kpi-select";
import { type Kpi } from "../client-setting/types";

type Props = {
  selectedKpiName: string;
  setSelectedKpiName: (kpiName: string) => void;
  inheritedClientSettingKpi: Kpi | null | undefined;
};

export const OptimizeKpiSelect = ({
  selectedKpiName,
  setSelectedKpiName,
  inheritedClientSettingKpi,
}: Props) => {
  const trackMMMEvent = useTrackMMMEvent(MMMTab.CREATE_CUSTOM_BUDGETS);
  const { kpis } = useClientKpis();

  return (
    <div>
      <label className="block text-xs font-semibold mb-1 h-4 max-h-[16px]">
        KPI
      </label>
      <div className="flex items-center gap-5">
        <KpiSelect
          inheritedClientSettingKpi={inheritedClientSettingKpi}
          className="w-72"
          options={kpis.map((kpi) => ({
            label: kpi.friendly_name,
            value: kpi.kpi_name,
          }))}
          value={selectedKpiName}
          onChange={(kpiName) => {
            trackMMMEvent({
              component: CreateCustomBudgetTrackedComponent.FORECAST_CHART,
              action: "onSelect",
              actionInfo: "Change selected KPI",
            });

            setSelectedKpiName(kpiName);
          }}
        />
      </div>
    </div>
  );
};
